import React from "react";
import { NotFoundPage } from "@v2/components/notFound";

export default function NotFoundHome() {
    return <NotFoundPage />;
}
